/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-10 10:14:00
 *
 *******************************************************/
// @flow

import { Fullscreen } from '@shopify/app-bridge/actions';
import { getSABAppInstance_Normal } from './app';

let SABFullscreenInstance = null;

function createSABFullscreenInstance() {
  SABFullscreenInstance = Fullscreen.create(getSABAppInstance_Normal());
}

export const enterSABFullscreen = fallbackFunc => {
  let unsubscribeExit = null;
  if (!SABFullscreenInstance) createSABFullscreenInstance();
  SABFullscreenInstance.dispatch(Fullscreen.Action.ENTER);

  // Subscribe action when exit - Fix issue modal
  if (typeof fallbackFunc === 'function') {
    const app = getSABAppInstance_Normal();
    unsubscribeExit = app.subscribe(Fullscreen.Action.EXIT, fallbackFunc);
  }
  return unsubscribeExit;
};

export const exitSABFullscreen = () => {
  if (!SABFullscreenInstance) createSABFullscreenInstance();
  SABFullscreenInstance.dispatch(Fullscreen.Action.EXIT);
};
